import React, { useState } from "react";
import {
  // Hidden,
  AppBar,
  Button,
  Drawer,
  Hidden,
  IconButton,
  List,
  ListItem,
  ListItemText,
  MenuItem,
  Toolbar,
  Typography,
} from "@mui/material";
import { withStyles, makeStyles } from "@mui/styles";
import { withSnackbar } from "notistack";
import { APPBARHEIGHT } from "../../app/theme/muiTheme";
import { useLocation, useNavigate } from "react-router-dom";
import {
  ABOUT,
  BLOGS,
  CONTACT,
  DEBATES,
  HOME,
  NEWS,
  SOCIAL,
  VLOGS,
} from "../../app/api/routes";
import clsx from "clsx";
import "./appBar.css";
import { Box } from "@mui/system";
import CancelIcon from "@mui/icons-material/Cancel";
const MEDIAARR = [
  {
    id: NEWS,
    value: "News",
  },
  {
    id: DEBATES,
    value: "Debates",
  },
];
const useStyles = makeStyles((theme) => ({
  appbar: {
    height: APPBARHEIGHT,
  },
}));

const AppBarPrimary = (props) => {
  const classes = useStyles();
  return (
    <AppBar position="fixed" className={classes.appbar}>
      <Toolbar>
        <div>test</div>
      </Toolbar>
    </AppBar>
  );
};

const AppBarPublic = withStyles((theme) => ({
  root: {
    zIndex: "1024",
    width: "100%",
    [theme.breakpoints.down("md")]: {
      height: theme.APPBARHEIGHTMD,
    },
    [theme.breakpoints.down("sm")]: {
      height: theme.APPBARHEIGHTSM,
    },
    [theme.breakpoints.up("md")]: {
      height: theme.APPBARHEIGHTLG,
    },
    display: "flex",
    justifyContent: "center",
    paddingLeft: "5%",
    paddingRight: "5%",
    backgroundColor: theme.palette.primary.main,
    [theme.breakpoints.down("md")]: {
      paddingLeft: "0%",
      paddingRight: "0%",
    },
  },
  nametxt: {
    fontSize: 22,
    fontWeight: "bold",
    textDecoration: "none",
    "&:hover": {
      cursor: "pointer",
    },
  },
  imgDiv: {
    flexGrow: 1,
  },
  rightsection: {
    display: "flex",
    flexGrow: 1,
    justifyContent: "space-between",
    alignItems: "center",
  },
  link: {
    textDecoration: "none",
    "&:hover": {
      cursor: "pointer",
    },
    fontWeight: "light",
  },
  selectedPath: {
    fontWeight: "bold",
  },
}))(({ classes, ...rest }) => {
  const location = useLocation().pathname;
  const navigate = useNavigate();
  const [drawer, setDrawer] = useState(false);
  const gotoPage = (e) => {
    e.stopPropagation();
    if (e.target.id) navigate(e.target.id);
  };

  const toggleDrawer = (open) => {
    setDrawer(open);
  };

  return (
    <AppBar position="fixed" className={classes.root}>
      <Toolbar>
        <div className={classes.imgDiv}>
          <div onClick={gotoPage}>
            <Typography className={clsx(classes.nametxt)} id={HOME}>
              Dibyanshu Pandey
            </Typography>
          </div>
        </div>
        <Hidden mdDown>
          <div className={classes.rightsection} onClick={gotoPage}>
            <span className={classes.link}>
              <Typography
                className={clsx(classes.links, {
                  [classes.selectedPath]: location === ABOUT,
                })}
                id={ABOUT}
              >
                About Me
              </Typography>
            </span>
            <span className={classes.link}>
              <Typography
                className={clsx(classes.links, {
                  [classes.selectedPath]: location === BLOGS,
                })}
                id={BLOGS}
              >
                Blogs
              </Typography>
            </span>
            <span className={classes.link}>
              <Typography
                className={clsx(classes.links, {
                  [classes.selectedPath]: location === VLOGS,
                })}
                id={VLOGS}
              >
                Vlogs
              </Typography>
            </span>
            <div className="dropdownmedia">
              <button className={clsx("dropbtnmedia")}>
                <Typography
                  className={clsx(classes.link, {
                    [classes.selectedPath]:
                      location === DEBATES || location === NEWS,
                  })}
                >
                  Media
                </Typography>
              </button>
              <div className="dropdown-content-media">
                {MEDIAARR.map((data, idx) => (
                  <MenuItem
                    key={idx}
                    className={classes.menuItem}
                    value={data.value}
                    id={data.id}
                  >
                    {data.value}
                  </MenuItem>
                ))}
              </div>
            </div>
            <span className={classes.link}>
              <Typography
                className={clsx(classes.links, {
                  [classes.selectedPath]: location === SOCIAL,
                })}
                id={SOCIAL}
              >
                Social Initiatives
              </Typography>
            </span>

            <Button variant="outlined" id={CONTACT}>
              Contact Us
            </Button>
          </div>
        </Hidden>
        <Hidden mdUp>
          <img
            src="/images/drawer.svg"
            onClick={() => {
              toggleDrawer(true);
            }}
            alt="drawer"
          />
        </Hidden>
      </Toolbar>
      <Drawer
        open={drawer}
        onClose={() => toggleDrawer(false)}
        anchor={"right"}
      >
        <Box
          sx={{ width: "80vw" }}
          role="presentation"
          onClick={() => toggleDrawer(false)}
          onKeyDown={() => toggleDrawer(false)}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <IconButton style={{}}>
              <CancelIcon color="secondary" />
            </IconButton>
          </div>
          <List>
            <ListItem
              button
              key={"About Me"}
              onClick={() => {
                navigate(ABOUT);
                toggleDrawer(false);
              }}
            >
              <ListItemText primary={"About Me"} />
            </ListItem>

            <ListItem
              button
              key={"Blogs"}
              onClick={() => {
                navigate(BLOGS);
                toggleDrawer(false);
              }}
            >
              <ListItemText primary={"Blogs"} />
            </ListItem>
            <ListItem
              button
              key={"Vlogs"}
              onClick={() => {
                navigate(VLOGS);
                toggleDrawer(false);
              }}
            >
              <ListItemText primary={"Vlogs"} />
            </ListItem>
            <ListItem
              button
              key={"News"}
              onClick={() => {
                navigate(NEWS);
                toggleDrawer(false);
              }}
            >
              <ListItemText primary={"News"} />
            </ListItem>
            <ListItem
              button
              key={"Debates"}
              onClick={() => {
                navigate(DEBATES);
                toggleDrawer(false);
              }}
            >
              <ListItemText primary={"Debates"} />
            </ListItem>
            <ListItem
              button
              key={"Social Initiatives"}
              onClick={() => {
                navigate(SOCIAL);
                toggleDrawer(false);
              }}
            >
              <ListItemText primary={"Social Initiatives"} />
            </ListItem>
            <ListItem
              button
              key={"Contact"}
              onClick={() => {
                navigate(CONTACT);
                toggleDrawer(false);
              }}
            >
              <ListItemText primary={"Contact Us"} />
            </ListItem>
          </List>
        </Box>
      </Drawer>
    </AppBar>
  );
});

const ToolbarSpace = () => {
  return <Toolbar style={{ opacity: 0 }} />;
};

export default withSnackbar(AppBarPrimary);
export { ToolbarSpace, AppBarPublic };
